import { FieldValue } from '@/_shared/components/field-value/index.js';
import { PackedGrid } from '@/_shared/components/packed-grid/index.js';
import { Section } from '@/_shared/components/section/index.js';
import { useTsRest } from '@/_shared/context/ts-rest.js';
import { DocumentLightningRegular } from '@fluentui/react-icons';
import { fromIso, toHumanReadable } from '@this/shared/dist/tools/datetime.js';
import { formatEur } from '@this/shared/dist/tools/number-format.js';

type ClaimProps = {
    claimId: string;
};

export function Claim({ claimId }: ClaimProps) {
    const tsr = useTsRest();

    const { data } = tsr.claimDetails.getClaimData.useQuery({
        queryKey: ['claimDetails', 'getClaimData', claimId],
        queryData: {
            params: {
                claimId,
            },
        },
        refetchInterval: 30_000,
    });

    return (
        <>
            <Section
                header={{
                    label: 'Schaden',
                    color: 'orange',
                    icon: <DocumentLightningRegular />,
                }}
            >
                <PackedGrid>
                    <FieldValue
                        label="Schadennummer"
                        value={data?.body.claimNumber}
                        copyableValue={data?.body.claimNumber}
                        nullPlaceholder="-"
                    />

                    <FieldValue
                        label="Schadentag"
                        value={
                            data?.body.claimDate
                                ? toHumanReadable(fromIso(data.body.claimDate), 'date_short_2digit')
                                : null
                        }
                        nullPlaceholder="-"
                    />

                    <FieldValue
                        label="Meldetag"
                        value={
                            data?.body.reportDate
                                ? toHumanReadable(fromIso(data.body.reportDate), 'date_short_2digit')
                                : null
                        }
                        nullPlaceholder="-"
                    />

                    <FieldValue label="Schadenart" value={data?.body.claimType} nullPlaceholder="-" />

                    <FieldValue label="Schadenursache" value={data?.body.claimCause} nullPlaceholder="-" />

                    <FieldValue
                        label="Schadenhöhe"
                        value={
                            data?.body.claimAmountEur !== null && data?.body.claimAmountEur !== undefined
                                ? formatEur(data.body.claimAmountEur)
                                : null
                        }
                        nullPlaceholder="-"
                    />

                    <FieldValue label="Schadenstatus" value={data?.body.claimStatus} nullPlaceholder="-" />

                    <FieldValue label="Regulierung durch" value={data?.body.claimProcessedBy} nullPlaceholder="-" />

                    <FieldValue
                        label="Sachbearbeiter"
                        value={data?.body.clerkName}
                        copyableValue={data?.body.clerkName}
                        nullPlaceholder="-"
                    />

                    <FieldValue
                        label="E-Mail"
                        value={data?.body.clerkEmail}
                        copyableValue={data?.body.clerkEmail}
                        nullPlaceholder="-"
                    />

                    <FieldValue
                        label="Telefon"
                        value={data?.body.clerkPhone}
                        copyableValue={data?.body.clerkPhone}
                        nullPlaceholder="-"
                    />
                </PackedGrid>
            </Section>

            {data?.body.insurerData && (
                <Section
                    header={{
                        label: 'Schadendaten des Versicherers',
                        color: 'orange',
                        icon: <DocumentLightningRegular />,
                    }}
                >
                    <PackedGrid>
                        <FieldValue label="Versicherer" value={data.body.insurerData.insurer} nullPlaceholder="-" />

                        <FieldValue
                            label="Schadennummer VU"
                            value={data.body.insurerData.claimNumber}
                            copyableValue={data.body.insurerData.claimNumber}
                            nullPlaceholder="-"
                        />

                        <FieldValue
                            label="Sachbearbeiter VU"
                            value={data.body.insurerData.clerkName}
                            nullPlaceholder="-"
                        />

                        <FieldValue
                            label="Telefon"
                            value={data.body.insurerData.clerkPhone}
                            copyableValue={data.body.insurerData.clerkPhone}
                            nullPlaceholder="-"
                        />
                    </PackedGrid>
                </Section>
            )}
        </>
    );
}
